/* =====================================================================
   Bies House — Welcome Survey  ·  lógica (production draft v2)
   - Markup vive AQUÍ (se inyecta en #bies-ws-root) → fuente única.
   - Auto-trigger en primera visita + una-vez-por-visitante (localStorage).
   - Branching Q2/Q3 según Q1 (6 caminos), multi-select, validación.
   - RECOMENDACIÓN PERSONALIZADA (v2): scoring por afinidad Q1+Q2+Q3 sobre el
     catálogo real (CFG.catalog, resuelto por Liquid). Elige el top-2.
   - Wiring Klaviyo: propiedades de perfil + alta en lista + evento de flow.
   - Config por window.BIES_WS_CONFIG (lo inyecta el snippet .liquid).

   PLACEHOLDERS a rellenar (marcados con  TODO ):
     · BIES_WS_CONFIG.klaviyo.publicKey   → public key (company_id) de Klaviyo
     · BIES_WS_CONFIG.trigger             → cuándo aparece
     · BIES_WS_CONFIG.discount            → único Klaviyo vs compartido
   ===================================================================== */
(function () {
  'use strict';

  // ── Config con defaults (el snippet .liquid puede sobreescribir) ──────
  var CFG = Object.assign({
    trigger:   { mode: 'delay', delaySeconds: 8, scrollPercent: 40 }, // 8s (Ceci 17-jun)
    reshowAfterDays: 14,           // si se cerró sin completar, re-mostrar pasados N días
    excludePaths: ['/checkout', '/cart', '/pages/tu-propio-pack'],
    discount:  { mode: 'shared', percent: 15, sharedCode: 'BIENVENIDO15', expiresDays: 14 }, // % en un solo sitio; sharedCode debe dar ese % en Shopify
    klaviyo:   { publicKey: '', listId: 'UYkAQL', metric: 'Completed Welcome Survey' }, // PENDIENTE PRODUCCIÓN: publicKey = 'V8ZRvc' (company_id BIES HOUSE)
    catalog:   null,               // catálogo real (lo inyecta el .liquid): [{handle,name,meta,price,image}]
    privacyUrl: '/policies/privacy-policy',
    catalogUrl: '/collections/all',
    storageKey: 'bies_ws_state'
  }, window.BIES_WS_CONFIG || {});

  // ── No mostrar en checkout/cart ni si ya se completó/cerró reciente ───
  function path() { return (location.pathname || '').toLowerCase(); }
  function isExcluded() { return CFG.excludePaths.some(function (p) { return path().indexOf(p) === 0; }); }
  function readState() { try { return JSON.parse(localStorage.getItem(CFG.storageKey) || '{}'); } catch (e) { return {}; } }
  function writeState(s) { try { localStorage.setItem(CFG.storageKey, JSON.stringify(s)); } catch (e) {} }
  // ── Cookie de "completado" (sobrevive al redirect /discount y a la
  //    canonicalización myshopify.com↔dominio propio mejor que localStorage) ──
  var DONE_COOKIE = 'bies_ws_done';
  function setDoneCookie() {
    try { document.cookie = DONE_COOKIE + '=1; max-age=31536000; path=/; SameSite=Lax'; } catch (e) {}
  }
  function hasDoneCookie() {
    try { return ('; ' + document.cookie).indexOf('; ' + DONE_COOKIE + '=1') !== -1; } catch (e) { return false; }
  }
  // Marca "completado" en AMBOS sitios (localStorage + cookie).
  function markCompleted(email) {
    var s = readState(); s.completed = true; if (email) s.email = email; writeState(s);
    setDoneCookie();
  }
  function shouldShow() {
    if (isExcluded()) return false;
    if (hasDoneCookie()) return false;                   // cookie de completado → nunca más
    var s = readState();
    if (s.completed) return false;                       // ya completó → nunca más
    if (s.dismissedAt) {                                  // cerró sin completar → respeta cooldown
      var days = (Date.now() - s.dismissedAt) / 86400000;
      if (days < CFG.reshowAfterDays) return false;
    }
    return true;
  }

  // ════════════════════════════════════════════════════════════
  //  BRANCHING DATA — 6 caminos (verbatim del mock v4, 2-jun)
  //  Nota v2: el campo `products` de cada camino queda SOLO como fallback
  //  de emergencia si CFG.catalog no resolvió (Liquid). La recomendación
  //  real la calcula scoreProducts() sobre CFG.catalog.
  // ════════════════════════════════════════════════════════════
  var branches = {
    stevia: {
      q2: { question: '¿Cómo piensas usarla principalmente?', multi: true, options: [
        ['cafe','En el café o té de cada día'], ['reposteria','En repostería y postres caseros'],
        ['cocina','En la cocina del día a día'], ['batidos','En batidos, shakes o desayunos proteicos'],
        ['ndecidido','Lo decidiré probando'] ] },
      q3: { question: '¿Habías probado stevia natural antes?', options: [
        ['habitual','Sí, la uso habitualmente'], ['probado-no','Sí, la probé pero no me convenció'],
        ['conoce','No, pero conozco la diferencia con la química'], ['newbie','No sabía que había dos tipos distintos'],
        ['nsnc','Honestamente no lo sé'] ] },
      thanksEyebrow: 'Para quitar el azúcar de tu día a día' },
    desayuno: {
      q2: { question: '¿Para qué momento del día principalmente?', multi: true, options: [
        ['desayuno','Desayuno'], ['mediamanana','Media mañana'], ['snack','Snack de tarde'],
        ['postre','Postre dulce'], ['varios','Varios momentos del día'] ] },
      q3: { question: '¿Tienes alguna preferencia o restricción?', multi: true, options: [
        ['gluten','Sin gluten'], ['proteina','Alto en proteína'], ['vegano','Vegano'],
        ['sin','Sin restricciones específicas'], ['depende','Depende del producto'] ] },
      thanksEyebrow: 'Para tus desayunos y snacks' },
    deporte: {
      q2: { question: '¿Qué tipo de actividad haces?', multi: true, options: [
        ['fuerza','Entrenamiento de fuerza'], ['cardio','Cardio o running'], ['mix','Mix fuerza y cardio'],
        ['ocasional','Deporte ocasional'], ['competi','Soy atleta o compito regularmente'] ] },
      q3: { question: '¿En qué momento la tomas habitualmente?', multi: true, options: [
        ['pre','Pre-entreno'], ['post','Post-entreno'], ['desayuno','En el desayuno'],
        ['snack','Como snack a media tarde'], ['variable','Varios momentos según el día'] ] },
      thanksEyebrow: 'Para acompañar tu entrenamiento' },
    clinico: {
      q2: { question: '¿Cuál es tu situación?', options: [
        ['tipo1','Diabetes tipo 1 diagnosticada'], ['tipo2','Diabetes tipo 2 diagnosticada'],
        ['prediabetes','Prediabetes o control de glucemia'], ['embarazo','Embarazo o lactancia (evitar azúcar)'],
        ['cuidando','Es por alguien que cuido'], ['peso','Control de peso por indicación médica'] ] },
      q3: { question: '¿Habías probado stevia natural antes?', options: [
        ['habitual','Sí, la uso habitualmente'], ['probado-no','Sí, la probé pero no me convenció'],
        ['conoce','No, pero conozco la diferencia con la química'], ['newbie','No sabía que había dos tipos distintos'],
        ['nsnc','Honestamente no lo sé'] ] },
      thanksEyebrow: 'Para gestionar el azúcar' },
    explorando: {
      q2: { question: '¿Qué tipo de productos te interesan más?', multi: true, options: [
        ['stevia','Stevia natural (alternativa al azúcar)'], ['matcha','Matcha y tés de calidad'],
        ['snacks','Granola, tortitas y snacks sanos'], ['proteicos','Productos proteicos'],
        ['todo','Todo me interesa, sin preferencia'] ] },
      q3: { question: '¿Qué te llamaría más probar primero?', options: [
        ['desayuno','Algo para desayunar'], ['bebida','Algo para el café o té'],
        ['dulce','Algo dulce sin azúcar'], ['mas-popular','Lo más popular entre clientes'] ] },
      thanksEyebrow: 'Para empezar a explorar Bies House' },
    refrescos: {
      q2: { question: '¿Qué tipo de bebidas quieres reemplazar?', multi: true, options: [
        ['refrescos-azucarados','Refrescos azucarados (Coca-Cola, Fanta…)'], ['zero','Refrescos light o zero'],
        ['energeticas','Bebidas energéticas'], ['cafes-cadena','Cafés azucarados de cadena'],
        ['zumos','Zumos comerciales o batidos azucarados'] ] },
      q3: { question: '¿Habías probado stevia natural antes?', options: [
        ['habitual','Sí, la uso habitualmente'], ['probado-no','Sí, la probé pero no me convenció'],
        ['conoce','No, pero conozco la diferencia con la química'], ['newbie','No sabía que había dos tipos distintos'],
        ['nsnc','Honestamente no lo sé'] ] },
      thanksEyebrow: 'Para reemplazar las bebidas azucaradas' }
  };

  // ════════════════════════════════════════════════════════════
  //  MOTOR DE RECOMENDACIÓN PERSONALIZADA (Q1 + Q2 + Q3)
  //  AFFINITY = afinidad de cada producto (por handle) con las señales.
  //  Los DATOS del producto (nombre/precio/imagen/URL) los pone Liquid en
  //  CFG.catalog. Aquí solo vive la afinidad → el cruce es por `handle`.
  //  Para cambiar una recomendación: ajusta pesos en AFFINITY o SIGNAL_WEIGHTS.
  // ════════════════════════════════════════════════════════════
  var AFFINITY = {
    'bies-endulzante-liquido':                          { azucar:4, clinico:4, cafe:2, reposteria:2, cocina:3, refrescos:1, explorar:1 },
    'matcha-bies-house':                                { te:4, cafe:2, ritual:3, energia:2, explorar:1 },
    'cafe-energizante-bies-house':                      { energia:4, energeticas:4, cafe:3, refrescos:2, deporte:1, pre:2 },
    'batido-de-proteina-sabor-chocolate':               { proteina:4, deporte:3, post:3, fuerza:3, dulce:1 },
    'batido-de-proteina-bies-house-sabor-frutos-rojos': { proteina:4, deporte:3, post:3, cardio:3 },
    'pancakes-bies-house':                              { desayuno:4, dulce:2, proteina:2, deporte:2, snack:1, postre:2 },
    'granola-bies-house':                               { desayuno:4, snack:3, fibra:3, explorar:1 },
    'granola-chocolate-bies-house':                     { desayuno:3, dulce:4, postre:3, snack:2, reposteria:2 },
    'bebida-instantanea-mix':                           { refrescos:4, hidratacion:4, zumos:3, energeticas:1, snack:1, explorar:2 },
    'desayuno-fitness-bies-house':                      { pack:6, desayuno:3, proteina:2, deporte:2 },
    'boost-energia-bies-house':                         { pack:6, energia:3, energeticas:2, deporte:1 }
  };

  // Cada valor de respuesta (Q1/Q2/Q3) → pesos que suma a los tags de afinidad.
  var SIGNAL_WEIGHTS = {
    // Q1
    stevia:'azucar:4', clinico:'azucar:3,clinico:4', desayuno:'desayuno:3,snack:1',
    deporte:'deporte:3,proteina:2', refrescos:'refrescos:3,hidratacion:1', explorando:'explorar:3',
    // Q2 stevia
    cafe:'cafe:3,te:1', reposteria:'reposteria:3,dulce:2', cocina:'cocina:3', batidos:'proteina:2,deporte:1', ndecidido:'explorar:1',
    // Q2 desayuno
    mediamanana:'snack:2', snack:'snack:3', postre:'dulce:2,postre:3', varios:'explorar:1',
    // Q2 deporte
    fuerza:'fuerza:3,proteina:1', cardio:'cardio:3', mix:'deporte:2', ocasional:'deporte:1', competi:'deporte:2,pack:3',
    // Q2 refrescos
    'refrescos-azucarados':'refrescos:2,dulce:1', zero:'refrescos:1', energeticas:'energeticas:4,energia:2', 'cafes-cadena':'cafe:3,energia:2', zumos:'zumos:3,hidratacion:1',
    // Q2 explorando
    matcha:'te:4,ritual:2,cafe:1', snacks:'snack:2,desayuno:1', proteicos:'proteina:3', todo:'pack:3,explorar:1',
    // Q3 (momento / intención)
    pre:'pre:2,energia:1', post:'post:3,proteina:1', 'mas-popular':'explorar:1', bebida:'cafe:1', dulce:'dulce:2',
    // Q3 dietéticos: NO filtran (no tenemos composición real de cada SKU). Suman 0.
    gluten:'', vegano:'', proteina:'proteina:2', sin:'', depende:''
  };

  // Suma señales de todas las respuestas → {tag: pesoAcumulado}
  function collectSignals(ans) {
    var acc = {}; var vals = [];
    ['q1','q2','q3'].forEach(function (q) {
      var a = ans[q];
      if (Array.isArray(a)) vals = vals.concat(a); else if (a) vals.push(a);
    });
    vals.forEach(function (v) {
      var spec = SIGNAL_WEIGHTS[v]; if (!spec) return;
      spec.split(',').forEach(function (pair) {
        if (!pair) return;
        var kv = pair.split(':'); acc[kv[0]] = (acc[kv[0]] || 0) + Number(kv[1]);
      });
    });
    return acc;
  }

  // Puntúa CFG.catalog (real) contra las señales y devuelve los `n` mejores.
  // Si no hay catálogo real, devuelve null y el caller usa el fallback.
  function scoreProducts(ans, n) {
    var catalog = (CFG.catalog && CFG.catalog.length) ? CFG.catalog : null;
    if (!catalog) return null;
    var signals = collectSignals(ans);
    var ranked = catalog.map(function (p) {
      var aff = AFFINITY[p.handle] || {}; var score = 0;
      for (var tag in aff) { if (signals[tag]) score += signals[tag] * aff[tag]; }
      return { p: p, score: score };
    }).sort(function (a, b) { return b.score - a.score; });
    var top = ranked.filter(function (r) { return r.score > 0; }).slice(0, n).map(function (r) { return r.p; });
    // Fallback core (Stevia + Matcha) si el perfil no puntuó lo suficiente.
    if (top.length < n) {
      ['bies-endulzante-liquido', 'matcha-bies-house'].forEach(function (h) {
        if (top.length >= n) return;
        var core = catalog.filter(function (p) { return p.handle === h; })[0];
        if (core && top.indexOf(core) < 0) top.push(core);
      });
    }
    return top.slice(0, n);
  }

  // ── Markup (fuente única; se inyecta en #bies-ws-root) ────────────────
  var CHEVRON = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="15 18 9 12 15 6"/></svg>';
  function q1OptionsHtml() {
    var rows = [
      ['stevia','Quiero eliminar el azúcar de mi día a día'],
      ['desayuno','Busco un desayuno o snack más sano'],
      ['deporte','Quiero proteína natural para deporte'],
      ['refrescos','Quiero reemplazar refrescos y bebidas azucaradas'],
      ['clinico','Diabetes o prediabetes (mía o de alguien cercano)'],
      ['explorando','Estoy explorando']
    ];
    return rows.map(function (r) {
      return '<button class="bws-opt" data-value="' + r[0] + '"><span class="bws-radio"></span>' + r[1] + '</button>';
    }).join('');
  }
  function markup() {
    return '' +
    '<div class="bws-dim" data-bws="dim"></div>' +
    '<div class="bws-sheet" data-bws="sheet" role="dialog" aria-modal="true" aria-label="Bienvenida a Bies House">' +
      '<div class="bws-handle"></div>' +
      '<nav class="bws-nav">' +
        '<button class="bws-back" data-bws="back" aria-label="Atrás">' + CHEVRON + '</button>' +
        '<div class="bws-progress" data-bws="progress">' +
          '<span class="bws-dot bws-active"></span><span class="bws-dot"></span><span class="bws-dot"></span><span class="bws-dot"></span>' +
        '</div>' +
        '<button class="bws-skip" data-bws="skip">Saltar</button>' +
      '</nav>' +
      '<div class="bws-content">' +
        '<div class="bws-title" data-bws="title"><h2>Cuéntanos un poco sobre ti</h2>' +
          '<p>Para recomendarte lo que mejor te encaje<br><span class="bws-subline">+ <strong>' + CFG.discount.percent + '%</strong> en tu primera compra</span></p></div>' +
        '<section class="bws-screen bws-active" data-screen="q1">' +
          '<h3 class="bws-question">¿Qué te ha traído a Bies House?</h3>' +
          '<p class="bws-helper">Si tienes varias razones, marca la principal.</p>' +
          '<div class="bws-options" data-question="q1">' + q1OptionsHtml() + '</div>' +
        '<button class="bws-bypass" data-bws="bypass">Solo quiero el ' + CFG.discount.percent + '%</button></section>' +
        '<section class="bws-screen" data-screen="q2"><h3 class="bws-question" data-bws="q2-question"></h3>' +
          '<p class="bws-multi-hint" data-bws="q2-hint" style="display:none">Puedes elegir varias.</p>' +
          '<div class="bws-options" data-question="q2" data-bws="q2-options"></div></section>' +
        '<section class="bws-screen" data-screen="q3"><p class="bws-intro">Y para terminar:</p>' +
          '<h3 class="bws-question" data-bws="q3-question"></h3>' +
          '<p class="bws-multi-hint" data-bws="q3-hint" style="display:none">Puedes elegir varias.</p>' +
          '<div class="bws-options" data-question="q3" data-bws="q3-options"></div></section>' +
        '<section class="bws-screen bws-email" data-screen="email"><h3 class="bws-question">Ya casi.</h3>' +
          '<p class="bws-email-reward">Tu ' + CFG.discount.percent + '% de descuento te espera</p>' +
          '<p class="bws-lead">Déjanos tu email y te mandamos tu <strong>' + CFG.discount.percent + '% de descuento</strong> + las recomendaciones que mejor te encajan según lo que nos has contado.</p>' +
          '<input type="email" class="bws-email-input" data-bws="email-input" placeholder="tu@email.com" autocomplete="email" inputmode="email">' +
          '<p class="bws-error" data-bws="email-error">Revisa el email, no parece válido.</p>' +
          '<p class="bws-privacy">Solo lo usamos para mandarte tu código y, de vez en cuando, productos que te puedan interesar. Te puedes dar de baja en un click. <a href="' + CFG.privacyUrl + '">Política de privacidad</a>.</p></section>' +
        '<section class="bws-screen bws-thanks" data-screen="thanks"><h2>Listo, <em>ya está</em>.</h2>' +
          '<p class="bws-thanks-lead" data-bws="thanks-lead"></p>' +
          '<div class="bws-discount-card" data-bws="discount-card"></div>' +
          '<div class="bws-rec-eyebrow" data-bws="rec-eyebrow"></div>' +
          '<div class="bws-rec-grid" data-bws="rec-grid"></div></section>' +
      '</div>' +
      '<footer class="bws-footer"><button class="bws-continue" data-bws="continue" disabled>Continuar</button></footer>' +
    '</div>';
  }

  // ── State + refs ──────────────────────────────────────────────────────
  var root, sheet, dim, backBtn, skipBtn, continueBtn, title, emailInput, emailError, progress;
  var screens = ['q1','q2','q3','email','thanks'];
  var idx = 0;
  var answers = {};
  var $ = function (sel) { return root.querySelector('[data-bws="' + sel + '"]'); };

  // ── Render dinámico ───────────────────────────────────────────────────
  function renderQuestion(qKey) {
    var b = branches[answers.q1]; if (!b) return;
    var data = b[qKey];
    $(qKey + '-question').textContent = data.question;
    var hint = $(qKey + '-hint'); if (hint) hint.style.display = data.multi ? 'block' : 'none';
    var widget = data.multi ? 'bws-check' : 'bws-radio';
    var cont = $(qKey + '-options'); cont.innerHTML = '';
    data.options.forEach(function (o) {
      var btn = document.createElement('button');
      btn.className = 'bws-opt'; btn.dataset.value = o[0];
      btn.innerHTML = '<span class="' + widget + '"></span>' + o[1];
      var cur = answers[qKey];
      if (data.multi) { if (Array.isArray(cur) && cur.indexOf(o[0]) >= 0) btn.classList.add('bws-selected'); }
      else { if (cur === o[0]) btn.classList.add('bws-selected'); }
      cont.appendChild(btn);
    });
  }
  function renderThanks() {
    var b = branches[answers.q1];
    $('rec-eyebrow').textContent = b ? b.thanksEyebrow : 'Lo más popular en Bies House';
    // tarjeta de descuento según modo
    var dc = $('discount-card');
    if (CFG.discount.mode === 'klaviyo_unique') {
      $('thanks-lead').textContent = 'Te hemos mandado tu código por email. Si no lo ves, mira en spam.';
      dc.innerHTML = '<div class="bws-discount-card-eyebrow">Tu ' + CFG.discount.percent + '%</div><h3>' + CFG.discount.percent + '% off</h3><div class="bws-sub">primera compra · en tu email</div>';
    } else {
      // Modelo "auto-apply" (discount link): el cliente NO copia código.
      // El descuento se arma en su sesión al pulsar "Ver el catálogo" (botón final,
      // que navega a /discount/CODE). Aquí lo avisamos + intento best-effort de
      // armarlo ya al llegar a esta pantalla para que el aviso sea fiel.
      $('thanks-lead').textContent = 'No necesitas copiar ningún código: tu descuento se aplica solo en tu compra.';
      dc.innerHTML = '<div class="bws-discount-card-eyebrow">Listo ✓</div><h3>' + CFG.discount.percent + '% off</h3>' +
        '<div class="bws-sub">ya activado · primera compra</div>' +
        '<div class="bws-expires">Válido durante ' + CFG.discount.expiresDays + ' días</div>';
      // Best-effort: arma el descuento en la sesión sin click (el botón final lo garantiza igualmente).
      try { fetch('/discount/' + encodeURIComponent(CFG.discount.sharedCode), { credentials: 'same-origin' }).catch(function () {}); } catch (e) {}
    }
    // productos — scoring Q1+Q2+Q3 sobre catálogo real; fallback al placeholder del mock
    var recs = scoreProducts(answers, 2);
    if (!recs) { // sin CFG.catalog: degradación elegante (no debería pasar en prod)
      recs = [];
    }
    var grid = $('rec-grid'); grid.innerHTML = '';
    recs.forEach(function (p) {
      var href = p.handle ? '/products/' + p.handle : (CFG.catalogUrl || '#');
      var imgHtml = p.image ? '<img src="' + p.image + '" alt="' + (p.name || '') + '">'
                            : '<div class="bws-bottle"></div>';
      var a = document.createElement('a');
      a.className = 'bws-rec-card'; a.href = href;
      a.innerHTML = '<div class="bws-rec-image">' + imgHtml + '</div>' +
        '<div class="bws-rec-name">' + p.name + '</div>' +
        '<div class="bws-rec-meta">' + (p.meta || '') + '</div>' +
        (p.price ? '<div class="bws-rec-price">' + p.price + '</div>' : '');
      grid.appendChild(a);
    });
  }

  // ── Navegación ────────────────────────────────────────────────────────
  function open() { sheet.classList.add('bws-open'); dim.classList.add('bws-visible'); kTrack('Started Welcome Survey'); }
  function close(reason) {
    sheet.classList.remove('bws-open'); dim.classList.remove('bws-visible');
    if (reason === 'dismiss') { var s = readState(); s.dismissedAt = Date.now(); writeState(s); }
  }
  function showScreen(i) {
    root.querySelectorAll('.bws-screen').forEach(function (s) { s.classList.remove('bws-active'); });
    var name = screens[i];
    if (name === 'q2') renderQuestion('q2');
    if (name === 'q3') renderQuestion('q3');
    if (name === 'thanks') renderThanks();
    root.querySelector('[data-screen="' + name + '"]').classList.add('bws-active');
    updateProgress(i); updateNav(i); updateContinue(i);
    if (name === 'thanks') { title.style.display = 'none'; continueBtn.textContent = 'Comprar con mi ' + CFG.discount.percent + '%'; continueBtn.disabled = false; }
    else if (name === 'email') { title.style.display = 'none'; continueBtn.textContent = 'Conseguir mi ' + CFG.discount.percent + '%'; }
    else { title.style.display = ''; continueBtn.textContent = 'Continuar'; }
  }
  function updateProgress(i) {
    var dots = root.querySelectorAll('.bws-dot'); var p = Math.min(i, 3);
    dots.forEach(function (d, k) { d.classList.remove('bws-active','bws-done'); if (k < p) d.classList.add('bws-done'); else if (k === p) d.classList.add('bws-active'); });
    progress.style.opacity = i === 4 ? '0' : '1';
  }
  function updateNav(i) {
    backBtn.classList.toggle('bws-visible', i > 0 && i < 4);
    skipBtn.style.opacity = i < 4 ? '1' : '0';
    skipBtn.style.pointerEvents = i < 4 ? 'auto' : 'none';
  }
  function updateContinue(i) {
    if (i >= 4) return;
    var name = screens[i];
    if (name === 'email') { var v = emailInput.value.trim(); continueBtn.disabled = !(v && /\S+@\S+\.\S+/.test(v)); }
    else { var a = answers[name]; continueBtn.disabled = Array.isArray(a) ? a.length === 0 : !a; }
  }

  // ── Klaviyo wiring ────────────────────────────────────────────────────
  function kIdentify(props) {
    try { window.klaviyo = window.klaviyo || []; window.klaviyo.push(['identify', props]);
          window._learnq = window._learnq || []; window._learnq.push(['identify', props]); } catch (e) {}
  }
  function kTrack(metric, props) {
    try { window.klaviyo = window.klaviyo || []; window.klaviyo.push(['track', metric, props || {}]); } catch (e) {}
  }
  function kSubscribe(email, props) {
    // Alta en lista vía Klaviyo Client Subscriptions API (consentimiento explícito).
    // Requiere CFG.klaviyo.publicKey (company_id). Si falta, solo identify+track.
    if (!CFG.klaviyo.publicKey || !CFG.klaviyo.listId) return Promise.resolve();
    var body = { data: { type: 'subscription', attributes: {
        profile: { data: { type: 'profile', attributes: { email: email, properties: props } } },
        custom_source: 'Welcome Survey' },
      relationships: { list: { data: { type: 'list', id: CFG.klaviyo.listId } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CFG.klaviyo.publicKey), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(body)
    }).catch(function () {});
  }

  function submitEmail() {
    var email = emailInput.value.trim();
    if (!/\S+@\S+\.\S+/.test(email)) { emailError.classList.add('bws-visible'); return false; }
    emailError.classList.remove('bws-visible');
    var props = {
      '$email': email,
      'BiesWS_Goal': answers.q1 || null,
      'BiesWS_Q2': Array.isArray(answers.q2) ? answers.q2.join(',') : (answers.q2 || null),
      'BiesWS_Q3': Array.isArray(answers.q3) ? answers.q3.join(',') : (answers.q3 || null),
      'BiesWS_Completed': true,
      'BiesWS_CompletedAt': new Date().toISOString()
    };
    kIdentify(props);
    kSubscribe(email, props);
    kTrack(CFG.klaviyo.metric, props);   // ← el flow `bienvenida_newsletter` puede dispararse con esta métrica o con la alta en lista
    markCompleted(email);
    try { localStorage.setItem('bies_ws_profile', JSON.stringify({ q1: answers.q1, q2: answers.q2, q3: answers.q3 })); } catch (e) {}                 // localStorage + cookie (gating robusto)
    return true;
  }

  // ── Eventos ───────────────────────────────────────────────────────────
  function wire() {
    root.querySelectorAll('.bws-options').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var opt = e.target.closest('.bws-opt'); if (!opt) return;
        var q = group.dataset.question; var value = opt.dataset.value;
        var isMulti = q !== 'q1' && answers.q1 && branches[answers.q1] && branches[answers.q1][q] && branches[answers.q1][q].multi === true;
        if (isMulti) {
          opt.classList.toggle('bws-selected');
          var cur = Array.isArray(answers[q]) ? answers[q] : [];
          if (opt.classList.contains('bws-selected')) { if (cur.indexOf(value) < 0) cur.push(value); }
          else { var k = cur.indexOf(value); if (k >= 0) cur.splice(k, 1); }
          answers[q] = cur;
        } else {
          group.querySelectorAll('.bws-opt').forEach(function (o) { o.classList.remove('bws-selected'); });
          opt.classList.add('bws-selected'); answers[q] = value;
        }
        if (q === 'q1') { delete answers.q2; delete answers.q3; }
        updateContinue(idx);
      });
    });
    emailInput.addEventListener('input', function () { emailError.classList.remove('bws-visible'); updateContinue(idx); });
    continueBtn.addEventListener('click', function () {
      if (idx === 4) {
        close('complete');
        markCompleted();   // belt-and-suspenders: persiste el flag (LS+cookie) ANTES del redirect
        // Discount link: activa el descuento en la sesión y redirige al catálogo.
        if (CFG.discount.mode === 'shared' && CFG.discount.sharedCode) {
          window.location.href = '/discount/' + encodeURIComponent(CFG.discount.sharedCode) +
            '?redirect=' + encodeURIComponent(CFG.catalogUrl);
        } else {
          window.location.href = CFG.catalogUrl;
        }
        return;
      }
      if (screens[idx] === 'email') { if (!submitEmail()) return; }
      idx++; showScreen(idx);
    });
    backBtn.addEventListener('click', function () { if (idx <= 0 || idx >= 4) return; idx = (answers._bypass && idx === 3) ? 0 : idx - 1; showScreen(idx); });
    skipBtn.addEventListener('click', function () { close('dismiss'); });
    var bypassBtn = $('bypass'); if (bypassBtn) bypassBtn.addEventListener('click', function () { answers._bypass = true; idx = 3; showScreen(3); });
    dim.addEventListener('click', function () { close('dismiss'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('bws-open')) close('dismiss'); });
    // copiar código compartido
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-bws="copy-code"]'); if (!c) return;
      try { navigator.clipboard.writeText(c.textContent.trim()); c.textContent = '¡Copiado!'; setTimeout(function () { c.textContent = CFG.discount.sharedCode; }, 1400); } catch (x) {}
    });
  }

  // ── Trigger ───────────────────────────────────────────────────────────
  function armTrigger() {
    var fired = false;
    // Interlock (13-jul): el survey vive en z-index máximo — si dispara con el
    // cookie banner visible, su dim BLOQUEA el banner (deadlock para el usuario);
    // si dispara con el cart drawer abierto, tapa la compra en curso. En ambos
    // casos posponemos con reintentos en vez de disparar encima.
    var fireAttempts = 0;
    function canFireNow() {
      var cookiesOpen = document.querySelector('#bies-cookies-overlay.show');
      var drawerOpen = document.querySelector('#bies-cart-drawer.is-open');
      return !cookiesOpen && !drawerOpen;
    }
    function fire() {
      if (fired) return;
      if (!canFireNow()) {
        fireAttempts++;
        if (fireAttempts <= 20) setTimeout(fire, 4000); // reintenta hasta ~80s; después desiste esta página
        return;
      }
      fired = true; open();
    }
    var t = CFG.trigger || {};
    if (t.mode === 'immediate') { fire(); return; }
    if (t.mode === 'scroll') {
      var onScroll = function () {
        var sc = (window.scrollY || document.documentElement.scrollTop);
        var h = (document.documentElement.scrollHeight - window.innerHeight) || 1;
        if ((sc / h) * 100 >= (t.scrollPercent || 40)) { window.removeEventListener('scroll', onScroll); fire(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      return;
    }
    if (t.mode === 'exit') { // exit-intent (desktop) + fallback delay (mobile)
      document.addEventListener('mouseout', function (e) { if (e.clientY <= 0) fire(); });
      setTimeout(fire, (t.delaySeconds || 20) * 1000);
      return;
    }
    // default: delay
    setTimeout(fire, (t.delaySeconds || 8) * 1000);
  }

  // ── Init ──────────────────────────────────────────────────────────────
  function init() {
    root = document.getElementById('bies-ws-root');
    if (!root) return;
    if (!shouldShow()) return;
    root.innerHTML = markup();
    sheet = $('sheet'); dim = $('dim'); backBtn = $('back'); skipBtn = $('skip');
    continueBtn = $('continue'); title = $('title'); emailInput = $('email-input');
    emailError = $('email-error'); progress = $('progress');
    wire(); showScreen(0); armTrigger();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
